





<template>
  <footer class="container">
    <div class="row text-center">
      <div class="col-12">
        <p>Copyright 2021 GS Elektromedizinische Geräte G. Stemple GmbH</p>
        <p>
          For more information please refer to our
          <a href="/terms">Terms and Conditions.</a>
        </p>
        <p>
          <a href="https://corpuls.world/en/legal/imprint/">Imprint</a> and <a href="https://corpuls.world/en/legal/privacy-policy/">Privacy Policy</a>
        </p>
      </div>
    </div>
  </footer>
</template>
<script>
export default {
  methods: {},
  beforeMount() {}
};
</script>

<style scoped>
footer {
  margin-top: 50px;
  margin-bottom: 20px;
}
p {
  margin-bottom: 0px;
  font-size: 15px;
  font-style: italic;
}
</style>
